var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "regist" },
    [
      !_vm.isRegistration
        ? [
            _vm._t("note"),
            _vm._v(" "),
            _vm.isError
              ? _c("div", { staticClass: "aCt errNote" }, [_vm._m(0)])
              : _vm._e(),
            _vm._v(" "),
            _c("passes", {
              attrs: {
                userinfo: _vm.userinfo,
                "csrf-name": _vm.dataCsrfName,
                csrf: _vm.dataCsrf,
                token: _vm.dataToken,
                "is-visible": _vm.isRegistration,
              },
              on: { "toggle-element": _vm.toggle, "show-error": _vm.showError },
            }),
          ]
        : [
            _c("p", [
              _vm._v(
                "お手持ちのワンタッチパスID（クラブ発行会員番号）の情報を入力してください。"
              ),
            ]),
            _vm._v(" "),
            _c("regist", {
              attrs: { "is-visible": _vm.isRegistration },
              on: { "toggle-element": _vm.toggle },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("このワンタッチパスは解除できません。"),
      _c("br"),
      _vm._v(
        "解除を希望される場合は大変お手数ですが発行元クラブへお問合せ下さい。"
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }